<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="noticeData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="domain" label="标题" prop="domain">
                    <a-input v-model="noticeData.title" v-if="is_vue_task" @blur="
                        () => {
                            $refs.title.onFieldBlur();
                        }
                        " />
                    <span class="form_span" v-else>{{noticeData.title}}</span>
                </a-form-model-item>
               <a-form-model-item label="链接地址" ref="link" prop="link" :labelCol="labelCol" :wrapperCol="wrapperCol"
                    style="width:100%;margin-top:10px;">
                    <a-input v-model="noticeData.link" v-if="is_vue_task" type="textarea" @blur="() => {
                                $refs.link.onFieldBlur();
                            }
                            " />
                    <span class="form_span" v-else>{{noticeData.link}}</span>
                </a-form-model-item>
                <a-form-model-item label="公告描述" ref="description" prop="description" :labelCol="labelCol" :wrapperCol="wrapperCol"
                    style="width:100%;margin-top:10px;">
                    <a-input v-model="noticeData.description" v-if="is_vue_task" type="textarea" style="height:400px;" @blur="() => {
                                $refs.description.onFieldBlur();
                            }
                            " />
                    <span class="form_span" v-else>{{noticeData.description}}</span>
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }" v-show="is_vue_task">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    'noticeadd':'新增公告',
    'noticedetail':'查看公告',
    'noticeedit':'编辑公告',
};
export default {
    data() {
        return {
            m_title,
            c_title:'',
            labelCol: { span: 6 },
            wrapperCol: { span:8 },
            rules: {
                title: [
                    { required: true, message: '请输入公告', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                link:[
                    { min: 1, max: 500, message: '请输入1~500个字符', trigger: 'blur' },
                ],
                description:[
                    { min: 1, max: 500, message: '请输入1~500个字符', trigger: 'blur' },
                ]
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            noticeData:{},
            selecterState:{
                isShow:false,
                rowsType:'radio' // or 'checkbox'，单选或多选
            },
            is_vue_task : true,
        };
    },
    components: {
    },
    
    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    console.log(this.noticeData);
                    if(this.noticeData.id){
                        //编辑
                        this.$store
                            .dispatch({
                                type: "notice/editnotice",
                                params: this.noticeData
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel()
                                    this.confirmLoading = false;
                                }
                            });
                    }
                    else{
                        //新增
                        this.$store
                            .dispatch({
                                type: "notice/addnotice",
                                params: this.noticeData
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    this.handleCancel()
                                }
                                this.confirmLoading = false;

                     
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_vue_task = params.action != 'noticedetail';
        let that = this;
        if (params.action != "noticeadd") {
            that.$store.dispatch({
                type: "notice/detailnotice",
                params:query
            }).then((res)=>{
                console.log(res);
                that.tLoading = false;
                let result = res.data.data;
                that.noticeData = result
            })
        }
        else{
            this.noticeData = {
                id:'',
                title:'',
                description:'',
                link:''
            }
        }
        
    }
};
</script>

<style lang="less" scoped>


.form_span{
   
}
</style>
